// @mui
import { Box, Typography } from '@mui/material';

// components
import { MotionContainer, varBounce } from '@components/Animate';
import { m } from 'framer-motion';

// ----------------------------------------------------------------------

export default function PageUnavailable() {
  return (
    <>
      <title>Page unavailable | Received Digital</title>

      <MotionContainer sx={{ maxWidth: 480 }}>
        <m.div variants={varBounce('in')}>
          <Typography variant="h3" component="p">
            Page unavailable
          </Typography>
        </m.div>

        <m.div variants={varBounce('in')}>
          <Typography sx={{ color: 'text.secondary' }}>
            Please check that you’ve entered the correct URL, or contact your administrator for help.
          </Typography>
        </m.div>

        <m.div variants={varBounce('in')}>
          <Box sx={{ my: 10 }}>
            <img src="/assets/illustrations/illustration_invalid_url.png" />
          </Box>
        </m.div>
      </MotionContainer>
    </>
  );
}
